import { Orientation } from '../_components/flow-builder/canvas-element/Orientation';
import { FlowConfig } from '../_components/flow-builder/TypeDefs';
import { DraggingItemType, JourneyCanvasState, JourneyStepAction, SidebarDataLoadingState, SidebarState } from '../modules/journey-canvas/utility/TypeDefs';

// config for flow builder, kept outside to prevent useEffect re-execution
export const FLOW_CONFIG: FlowConfig = {
  itemWidth: 300,
  itemHeight: 60,
  stepCardHeight: 160,
  stepCardWidth: 360,
  orientation: Orientation.HORIZONTAL,
  canvasBackgroundColor: '#F1F1F1',
};

// Setting initial state
export const initialState: JourneyCanvasState = {
  allServices: [],
  associatedServices: [],
  searchTerm: '',
  selectedConnector: { to: '', from: '' },
  eventSchemaMap: {},
  selectedEventSchema: undefined,
  flowBuilderSizeState: { width: 500, height: 500 },
  flowItems: [],
  stepItems: [],
  deletedStepItems: [],
  flowConnectors: [],
  stepConnectors: [],
  deletedStepConnectors: [],
  draggingItem: { item: null, startOffset: { x: 0, y: 0 }, itemType: DraggingItemType.NONE },
  flowItemDataMap: {},
  sidebarState: SidebarState.NONE,
  journeyName: '',
  journeyStepName: '',
  journeyDescription: '',
  journeyStepDescription: '',
  journeyStatus: '',
  journeyVersion: 0,
  journeyCategory: '',
  ingressNodeId: '',
  saveJourneyBtnEnabled: false,
  enableActiveJourney: false,
  startSelected: false,
  updateVersion: false,
  serviceOperations: [],
  sidebarDataLoadingState: SidebarDataLoadingState.NONE,
  allServicesDataLoad: {
    loadingMore: false,
    page: 0,
    noLoadMore: false,
    failed: false
  },
  isRootExternal: false,
  designingCEM: false,
  showNotifyDialog: false,
  showJourneyStepModal: false,
  maxExecutionTimeInput: { hours: '', minutes: '', seconds: '' },
  maxExecutionTime: 0,
  uniqueIdentifiers: [],
  parentJourney: {
    flowItems: [],
    flowConnectors: [],
    ingressNodeId: '',
    isRootExternal: false
  },
  notifyApiError: false,
  designingStep: false,
  initiateStepCardVisible: false,
  validation: {
    sidebarInvalidSearch: false,
  },
  designingInitialStepJourney: true,
  stepJourneyDataMap: {},
  stepCardUUID: '',
  prevStepCardUUID: '',
  dropdownEndpointValues: [],
  stepCardMenuDropdown: {
    isVisible: false,
    xCoordinate: 0,
    yCoordinate: 0
  },
  createdJourney: false,
  schedulerModal: false,
  showTransformPayloadModal: false,
  dropDownServicesPayload: [],
  payloadTransformations: [],
  payloadTransformationNodeId: '',
  journeyStepAction: JourneyStepAction.NONE,
  saveJourneyToDesignCEMModal: false,
  payloadTransformationEventName: '',
  payloadTransformationEventVersion: 0,
  cemSaveBtn: false,
  showCondExpModal: false,
  isJourneyCreated: false,
  journeyType: '',
  showExternalOnSubsequentStepModal: false,
  showExternalEventConfirmationModal: false,
};

export const journeyCanvasConstants = {
  itemHorizontalGap: 150,
  itemVerticalGap: 150,
  canvasMarginAndBorder: 0,
  rootItemPosition: {
    x: 250,
    y: 40
  },
  rootExternalItemPosition: {
    x: 50,
    y: 40
  },
  defaultEventMapEventStatus: 'not started',
  allServicesPageSize: 100,
  flowItemBtnHeight: 16,
  flowItemMepBtnHeight: 19,
  cemRootItemIconSize: 12,
  stepStartingItemIconSize: 17
};

export const paginationConstants = {
  showTenItems: 10,
  showTwentyFiveItems: 25,
  showFiftyItems: 50,
};

export const stepItemConfig = {
  fillColor: '#FFFFFF',
  strokeColor: '#FFFFFF'
};
